import React from "react";

export function LogOutIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M9 4V3C9 2.44772 8.55228 2 8 2H4C3.44772 2 3 2.44772 3 3V13C3 13.5523 3.44772 14 4 14H8C8.55228 14 9 13.5523 9 13V12"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M6 8H14"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M12 5L15 8L12 11"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
    </svg>
  );
}
